import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]

import { withDefaults } from 'vue';
  
  interface IProps {
    color?: string;
  }
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExportIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };

  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M9.32031 6.49994L11.8803 3.93994L14.4403 6.49994",
      stroke: __props.color || '#697B8E',
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("path", {
      d: "M11.8799 14.1798V4.00977",
      stroke: __props.color || '#697B8E',
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_3),
    _createElementVNode("path", {
      d: "M4 12C4 16.42 7 20 12 20C17 20 20 16.42 20 12",
      stroke: __props.color || '#697B8E',
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_4)
  ]))
}
}

})